export default __webpack_public_path__ + "static/media/logo.63ee99f5.png";